import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EventWorldService } from '../events/event-world.service';
import { EventWorldModel } from '../events/EventWorldModel';
import { ImagesModel } from '../events/ImagesModel';

@Component({
    // moduleId: module.id,
    selector: 'country-events',
    templateUrl: 'country-events.component.html',
    styleUrls: ['country-events.component.scss']
})
export class CountryEventsComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor( 
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :EventWorldService,
          private route: ActivatedRoute,
          ) {      this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         ngOnInit() {
          // this.lang = localStorage.getItem('theme_lang');
          debugger;
      
          if(this.id > 0)
          {
            debugger;
            this.modelService.GetAllByCountryId(this.id).subscribe(data=>{
                this.rows=data;
                console.log("modelObject",this.rows)
            })
      
  
          }
          else{
          }
  
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: EventWorldModel = new EventWorldModel();
      rows :EventWorldModel[]= [];
  
      mainForm: FormGroup = new FormGroup({
          id: new FormControl(),
          images: new FormControl(),
          titleEn: new FormControl(),
          titleAr: new FormControl(),
          titleFr: new FormControl(),
          description: new FormControl(),
          latitude: new FormControl(),
          longitude: new FormControl(),
          countryId: new FormControl(),
          cityId: new FormControl(),
          userId: new FormControl(),
          date: new FormControl(),
      });
     
        files:ImagesModel[]=[];
       public picurl: string ='';
       editEnabled = true;
        setFileToList(){
          debugger;
            var file = new ImagesModel();
            file.eventWorldId = this.id ;
            file.imageURL = this.picurl;
            file.id = 0;
            this.picurl='';
            this.editEnabled = true;
            this.files.push(file);
        }
        goBack(){
          this.router.navigate(['/blimp/events']);
        }
    selectedImages:ImagesModel={};


        setImage(EventId){
          debugger;
          var i = this.files.findIndex(x=>x.eventWorldId == this.id);
          if(i>-1){
            this.selectedImages = this.files[i];
          }
          else{
            this.selectedImages.imageURL=''
          }
          
        }
        EventDetails(id){
          this.router.navigate(['/country-event-details/',id]);
          
        }
    
        // CountryEvents(countryId){
        //     this.router.navigate(['/country-events/',this.modelObject.id]);
        // }
  }
  